module.exports = __webpack_public_path__ + "images/home-slides/couch.b87ddd9bec957e99b34e7cb9f7bec31d.jpg";